import { jsx as _jsx } from "react/jsx-runtime";
/* eslint-disable react/jsx-no-bind */
import React, { useMemo } from 'react';
import { CnDialog, CnForm, formilyCore } from '@alife/cn-ui';
import $i18n from 'panda-i18n';
import getSchema from './schema';
import './index.scss';
const { createForm } = formilyCore;
/**
 * common-date
 * @param {*} props
 * @returns
 */
export default function CommonDate(props) {
    const form = useMemo(() => {
        return createForm({
            values: {
                dates: props.dates,
            },
        });
    }, [props.dates]);
    async function onSubmit() {
        try {
            await form.validate();
            const data = form.values.dates;
            props.onSave && props.onSave(data);
            props.onClose();
        }
        catch (error) {
            console.log(error);
        }
    }
    return (_jsx(CnDialog, { visible: props.visible, title: $i18n.get({ id: 'EditCommonTime', dm: '编辑常用时间' }), className: 'common-date', onCancel: props.onClose, onOk: onSubmit, onClose: props.onClose, children: _jsx("div", { className: 'table-content', children: _jsx(CnForm, { form: form, schema: getSchema($i18n) }) }) }));
}
